<template lang="pug">
  v-tooltip(v-model="showTooltip" bottom)
    template(v-slot:activator="{ on }")
      v-btn(icon v-on="on")
        v-icon(color="grey lighten-1") mdi-information-outline
    div
      slot
</template>

<script>
  export default {
    name: "TooltipSimple",
    data: () => ({
      showTooltip: false,
    }),
  }
</script>

<style lang="sass">
</style>